import React, { useMemo, useState, useEffect } from "react";
import { Select } from "@chakra-ui/react";
import { FieldWrapper } from "../../components/form/FieldWrapper";
import { NullableSwitch } from "../../components/form/NullableSwitch";
import { useDisabled, useNAState, isEmptyValue } from "../../utils/formField";

type Props = {
  field: any;               
  value?: any;              
  readOnly?: any;
  invalid?: boolean;
  submitted?: boolean;
};

const SelectionField: React.FC<Props> = ({
  field,
  value = "",
  readOnly,
  invalid,
  submitted = false,
}) => {
  const nullable = field?.nullable === true;
  const isMultiple: boolean = field?.multiple === true;

  
  const { mode, setMode, text, setText } = useNAState({
    value: isMultiple ? "" : (value as string), 
    nullable,
  });
  const { ro, disabled } = useDisabled({ readOnly, nullable, mode });

  
  const [multi, setMulti] = useState<string[]>(
    Array.isArray(value) ? value : (typeof value === "string" && value ? [value] : [])
  );

  
  useEffect(() => {
    if (isMultiple) {
      if (Array.isArray(value)) setMulti(value);
      else if (typeof value === "string" && value) setMulti([value]);
      else setMulti([]);
    } else {
      
      
    }
  }, [value, isMultiple]);

  
  const requiredNow = !nullable || mode === "val";

  
  
  
  const currentValue = isMultiple ? multi : text;

  
  const derivedInvalid = !!invalid || (submitted && requiredNow && isEmptyValue(currentValue));

  const options: string[] = useMemo(() => field?.options ?? [], [field?.options]);

  return (
    <FieldWrapper field={field} invalid={derivedInvalid}>
      <NullableSwitch
        nullable={nullable}
        mode={mode}
        setMode={setMode}
        readOnly={ro}
      >
        <Select
          name={!ro && requiredNow ? field.name : undefined}
          value={isMultiple ? multi : (text || "")}
          onChange={(e) => {
            if (isMultiple) {
              const selected = Array.from(e.currentTarget.selectedOptions).map(o => o.value);
              setMulti(selected);
            } else {
              setText(e.target.value);
            }
          }}
          isDisabled={disabled}
          isReadOnly={ro as any} 
          multiple={isMultiple}
        >
          {!isMultiple && (
            <option value="">{/* placeholder */}Select…</option>
          )}
          {options.map((opt, idx) => (
            <option key={idx} value={opt}>
              {opt}
            </option>
          ))}
        </Select>
      </NullableSwitch>

      {ro && (
        <>
          {nullable ? (
            mode === "na" ? (
              <input type="hidden" name={field.name} value="N/A" />
            ) : isMultiple ? (
              multi.map((v, i) => (
                <input key={i} type="hidden" name={field.name} value={v} />
              ))
            ) : (
              <input type="hidden" name={field.name} value={text} />
            )
          ) : isMultiple ? (
            multi.map((v, i) => (
              <input key={i} type="hidden" name={field.name} value={v} />
            ))
          ) : (
            <input type="hidden" name={field.name} value={text} />
          )}
        </>
      )}

      {!ro && nullable && mode === "na" && (
        <input type="hidden" name={field.name} value="N/A" />
      )}
    </FieldWrapper>
  );
};

export default SelectionField;
